export default (function (_ref) {
  var request = _ref.request;
  return {
    provincialProductionAdd: function provincialProductionAdd(data) {
      return request({
        url: '/mng/provincialProduction/add',
        method: 'post',
        data: data
      });
    },
    provincialProductionModify: function provincialProductionModify(data) {
      return request({
        url: "/mng/provincialProduction/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    provincialProductionDel: function provincialProductionDel(id) {
      return request({
        url: "/mng/provincialProduction/".concat(id, "/del"),
        method: 'delete'
      });
    },
    provincialProductionQuery: function provincialProductionQuery(data) {
      return request({
        url: '/mng/provincialProduction/query',
        method: 'get',
        params: data
      });
    },
    provincialProductionDetail: function provincialProductionDetail(id) {
      return request({
        url: "/mng/provincialProduction/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});